import React from 'react';

import classNames from 'classnames';

import classes from './RankCell.module.scss';
import { GridTableCell } from '../../../../../../shared/components/table-components';
import { getValueOrDash } from '../../../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';
import { getIsNullish } from '../../../../../../shared/utils/jsUtils';

type RankCellProps = {
  rank: number;
};

const RankCell = ({ rank }: RankCellProps) => {
  const className = classNames(classes.rankCell, {
    [classes.topThree]: !getIsNullish(rank) && rank <= 3,
  });

  return (
    <GridTableCell className={className} justify="center" align="center">
      {getValueOrDash(rank)}
    </GridTableCell>
  );
};

export { RankCell };
